import LogRocket from "logrocket";
LogRocket.init("3gwxd3/feeder-kgg5a");

export function identify(user: any) {
  if (!user || !user.uid) {
    return;
  }

  LogRocket.identify(user.uid, {
    name: user.displayName || undefined,
    email: user.email || undefined,
    subscriptionType: "pro",
  });
}

export function reset() {
  LogRocket.startNewSession();
}
